import React from "react";
import './CreateSequenceStyles.css';

const daysList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const DeliveryPreferenceComponent = ({
  allDays,
  selectedDays,
  handleAllDaysToggle,
  handleDayToggle,
  deliveryTimeType,
  setDeliveryTimeType,
  customTimeFrom,
  setCustomTimeFrom,
  customTimeTo,
  setCustomTimeTo
}) => (
  <div className="delivery-preference-card mb-2">
    <label className="form-label">Days</label>
    <div className="mb-2">
      <button
        type="button"
        className={`btn btn-sm ${allDays ? 'btn-success' : 'btn-outline-success'}`}
        onClick={handleAllDaysToggle}
        style={{ marginRight: 8 }}
      >
        All Days
      </button>
      {daysList.map(day => (
        <span
          key={day}
          className={`day-block${allDays || selectedDays.includes(day) ? ' selected' : ''}`}
          onClick={() => handleDayToggle(day)}
        >
          {day.slice(0, 3)}
        </span>
      ))}
    </div>
    <label className="form-label">Time</label>
    <div className="time-block">
      <label>
        <input
          type="radio"
          name="deliveryTime"
          value="any"
          checked={deliveryTimeType === 'any'}
          onChange={() => setDeliveryTimeType('any')}
        />{' '}
        Any Time
      </label>
      <label>
        <input
          type="radio"
          name="deliveryTime"
          value="custom"
          checked={deliveryTimeType === 'custom'}
          onChange={() => setDeliveryTimeType('custom')}
        />{' '}
        Custom Time
      </label>
      {deliveryTimeType === 'custom' && (
        <>
          <input
            type="time"
            value={customTimeFrom}
            onChange={e => setCustomTimeFrom(e.target.value)}
            className="form-control"
            style={{ width: 90 }}
          />
          <span>to</span>
          <input
            type="time"
            value={customTimeTo}
            onChange={e => setCustomTimeTo(e.target.value)}
            className="form-control"
            style={{ width: 90 }}
          />
        </>
      )}
    </div>
  </div>
);

export default DeliveryPreferenceComponent;